import { getConnectorById } from '@/store/connectors';
import { ConnectedApp } from '@/store/user-connectors';

import { ConnectorIds } from '../constants';
import { IConnector } from '../dto/connectors/Interface';
import { IUserConnector } from '../dto/user-connectors/Interface';

export function getConnectedApps(
  connectors: IConnector[],
  userConnectors: IUserConnector[]
): ConnectedApp[] {
  const apps: ConnectedApp[] = [];

  for (const uc of userConnectors) {
    const { connectorId } = uc;
    const connector = getConnectorById(connectors, connectorId as ConnectorIds);

    if (connector) {
      apps.push({
        authConfigFields: connector.authConfigFields,
        authType: connector.authType,
        connectorId: connector.connectorId,
        description: connector.description,
        isConnected: connector.isConnected,
        name: connector.name,
        userConnectorId: uc.id,
        userId: uc.userId,
      });
    }
  }

  const unusedConnectors = connectors.filter(
    (conn) => !apps.map((app) => app.connectorId).includes(conn.connectorId)
  );

  unusedConnectors.map((conn) =>
    apps.push({
      authConfigFields: conn.authConfigFields,
      authType: conn.authType,
      connectorId: conn.connectorId,
      description: conn.description,
      isConnected: false,
      name: conn.name,
      userConnectorId: undefined,
      userId: undefined,
    })
  );

  return apps;
}
